import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const gatusMonitorPlugin = createPlugin({
  id: 'gatus-monitor',
  routes: {
    root: rootRouteRef,
  },
});

export const GatusMonitorPage = gatusMonitorPlugin.provide(
  createRoutableExtension({
    name: 'GatusMonitorPage',
    component: () =>
      import('./components/GatusComponent').then(m => m.GatusComponent),
    mountPoint: rootRouteRef,
  }),
);
